import { Trans } from '@lingui/macro'

export const postalCodeTrans = <Trans>FORM_TRANSLATION_POSTAL_CODE_FORMAT_X1X_1X1_HELPER_TEXT</Trans>
export const requiredTrans = <Trans>This field is required</Trans>
export const emailTrans = <Trans>Must be valid email</Trans>
export const phoneTrans = (
  <Trans>Phone Number must have at least 10 digits</Trans>
)
export const dateRangeRequiredTrans = (
  <Trans>*You need to provide both end and a start point dates</Trans>
)
export const questionRequiredTrans = <Trans>This question is required</Trans>
export const questionRequiredTransWithStar = (
  <Trans>*This question is required</Trans>
)
export const requiredInt = <Trans>Amount entered must be an integer</Trans>

export const requiredSite = (
  <Trans>
    You have to enter a valid site address, including https:// or http://
  </Trans>
)
export const maxLength = ({ max }: { max: number }): JSX.Element => <Trans>Must be at most {max} chars</Trans>

export const PHONE_NUMBER_FORMAT_HELPER_TEXT = <Trans>PHONE_NUMBER_FORMAT_HELPER_TEXT</Trans>
export const URL_FORMAT_HELPER_TEXT = <Trans>URL_FORMAT_HELPER_TEXT</Trans>
export const EMAIL_FORMAT_HELPER_TEXT = <Trans>EMAIL_FORMAT_HELPER_TEXT</Trans>
export const INVALID_DATE_ERROR = <Trans>INVALID_DATE_ERROR</Trans>
